export default __webpack_public_path__ + "static/feature10-33ae69abdb5b2d97cdcd2dbd419b5f2a.webp";